import React from "react";
import { Grid, Box, Divider, Typography } from "@mui/material";
import { useSelector } from "react-redux";

import LeftSideNavbar from "../components/leftSideNavbar.component";
import TopBreadcrumbs from "../components/topBreadcrumbs.component";
import WIPTabs from "../components/WIP/WIPTabs.component";
import WIPDataGrid from "../components/WIP/WIPDataGrid.component";
import WIPActionNeeded from "../components/WIP/WIPActionNeeded.component";
import WIPAnalytics from "../components/WIP/WIPAnalytics.component";
import WIPBatchViewPage from "./wipBatchView.page";
import WIPBatchListPage from "./wipBatchList.page";

const WIPPage = () => {
  const selectedTab = useSelector(
    (state) => state.wip?.selectedTab || "wipData"
  );

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <LeftSideNavbar />
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: "100%" }}>
          <TopBreadcrumbs />
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="h6" style={{ fontSize: 20, fontWeight: 600 }}>
              WIP Tracker
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ fontSize: 14, fontWeight: 400, marginBottom: 8 }}
          >
            Track work-in-progress from development to delivery
          </Typography>
          <Divider />
        </Box>

        <Box sx={{ flex: 1 }}>
          <WIPTabs />
          {selectedTab === "wipActionNeeded" ? (
            <WIPActionNeeded />
          ) : selectedTab === "batch" ? (
            <WIPBatchListPage />
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default WIPPage;
